import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as appsActions from "../../actions/appsActions";
import * as constants from "../../constants";

const createAppLogic = createLogic({
	type: ActionTypes.CREATE_APP,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.post(
					"/apps",
					Object.assign(
						{},
						{
							name: action.name,
							key: action.key,
						}
					)
				)
					.then(data => {
						dispatch(appsActions.createAppSuccess(data.data));
						done();
					})
					.catch(error => {
						dispatch(appsActions.createAppFail(error));
						done();
					});
			});
	},
});

export default [createAppLogic];
